module.exports = __webpack_public_path__ + "img/1536188621.d42b7f0e.jpg";